<div sxCol [class.disabled]="readonly" (click)="onFieldClicked()" sxMargin="15px 0 0">

  @if (label && selectedInputType !== 'time') {
    <div sxPadding="0 0 4px 12px" sxRow sxDistribution="start"
      sxAlign="center" sxGap="5px" [class.rejectInput]="readonly || fieldCallback">
      <p sxMargin="0" sxTextSize="small" sxColor="three" sxCapitalize="">{{ label }}
        @if (required) {
          <span sxColor="danger">*</span>
        }
      </p>
    </div>
  }

  <div sxRow sxDistribution="spaceBetween" sxTextSize="medium" sxAlign="center" sxGap="5px"
    [class.rejectInput]="readonly || fieldCallback" sxBorderColor="one" sxBorderWidth="small"
    [sxPadding]="type === 'dropdown' ? '0 medium': 'medium'" sxBackground="light" sxRadius="small" sxMinHeight="58px"
    [class.focused]="isFocused">

    @if (iconStart) {
      <ion-icon [name]="iconStart" sxColor="two" sxTextSize="22px" sxFlexShrink="0"></ion-icon>
    }

    @if (showDialCodeSelector) {
      <div (click)="openCountryCodeSelector()" (keydown.enter)="openCountryCodeSelector()"
        (keydown.space)="openCountryCodeSelector()" role="button" tabindex="0" aria-label="Select country code"
        sxRow sxAlign="center"
        sxDistribution="center" sxGap="5px" sxBorderWidth="0 small 0 0" sxBorderColor="one" sxPadding="0 small 0 0">
        {{ countryCode }}
        <ion-icon name="chevron-down-outline"></ion-icon>
      </div>
    }


    @if (selectedInputType == 'phone') {
      <input class="input-field" type="tel" [(ngModel)]="phoneInput"
        [readonly]="readonly" [placeholder]="placeholder ? placeholder : ''" (ngModelChange)="onPhoneInputChange()"
        [attr.aria-label]="label || null" [attr.aria-required]="required" [attr.aria-invalid]="!!errorNote"
        [attr.aria-describedby]="(errorNote || helpNote) ? describedById : null">
    }

    @if (selectedInputType == 'input') {
      <input class="input-field" [id]="inputId" [readonly]="readonly"
        [(ngModel)]="value" (focusin)="onFocusChanges(true)" (focusout)="onFocusChanges(false)"
        (ngModelChange)="onValueChange()" (change)="doValidation()" [placeholder]="placeholder ? placeholder : ''"
        [type]="type" [attr.aria-label]="label || null" [attr.aria-required]="required"
        [attr.aria-invalid]="!!errorNote" [attr.aria-describedby]="(errorNote || helpNote) ? describedById : null"
        [ngClass]="type === 'datetime-local' ? 'inline-flex items-center box-border' : ''">
    }

    @if (selectedInputType == 'date') {
      <div class="date-segments" sxRow sxAlign="center" sxWidth="fill" sxGap="2px"
        [attr.aria-label]="label || null" [attr.aria-invalid]="!!errorNote">
        <input class="date-seg" #dayInput type="text" inputmode="numeric" maxlength="2" placeholder="DD"
          [readonly]="readonly" [(ngModel)]="dateDay" (ngModelChange)="onDateSegmentInput('day', monthInput)"
          (focusin)="onFocusChanges(true)" (focusout)="onFocusChanges(false)" aria-label="Day">
        <span class="date-sep">/</span>
        <input class="date-seg" #monthInput type="text" inputmode="numeric" maxlength="2" placeholder="MM"
          [readonly]="readonly" [(ngModel)]="dateMonth" (ngModelChange)="onDateSegmentInput('month', yearInput)"
          (focusin)="onFocusChanges(true)" (focusout)="onFocusChanges(false)" aria-label="Month">
        <span class="date-sep">/</span>
        <input class="date-seg date-seg-year" #yearInput type="text" inputmode="numeric" maxlength="4" placeholder="YYYY"
          [readonly]="readonly" [(ngModel)]="dateYear" (ngModelChange)="onDateSegmentInput('year')"
          (focusin)="onFocusChanges(true)" (focusout)="onFocusChanges(false)" aria-label="Year">

        <div class="date-calendar">
          <ion-icon class="date-calendar-icon" name="calendar-outline"></ion-icon>
          <input class="native-date-overlay" #nativeDate type="date" [value]="value || ''"
            [disabled]="readonly" (change)="onNativeDatePicked(nativeDate.value)" aria-label="Open calendar">
        </div>
      </div>
    }


    @if (selectedInputType == 'time') {
      <div sxRow sxWidth="full" sxDistribution="spaceBetween" sxAlign="center">
        @if (label) {
          <div sxRow sxDistribution="start" sxAlign="center" sxGap="5px"
            [class.rejectInput]="readonly || fieldCallback">
            <p sxMargin="0" sxTextSize="medium" sxColor="two" sxCapitalize="">{{ label }}
              @if (required) {
                <span sxColor="danger">*</span>
              }
            </p>
          </div>
        }
        <input (ngModelChange)="onValueChange($event)" (change)="doValidation()" sxBorderColor="rgba(0,0,0,0.30)"
          sxBorderWidth="1px" sxRadius="5px" [(ngModel)]="value" type="time" [attr.aria-label]="label || null"
          [attr.aria-required]="required" [attr.aria-invalid]="!!errorNote">
      </div>
    }

    @if (selectedInputType == 'textarea') {
      <textarea [readonly]="readonly" sxWidth="fill" sxPadding="0" sxMargin="0"
        [(ngModel)]="value" sxHeight="60px" (focusin)="onFocusChanges(true)" (focusout)="onFocusChanges(false)"
        (ngModelChange)="onValueChange()" (change)="doValidation()" [placeholder]="placeholder ? placeholder : ''"
        [attr.aria-label]="label || null" [attr.aria-required]="required" [attr.aria-invalid]="!!errorNote"
        [attr.aria-describedby]="(errorNote || helpNote) ? describedById : null"
        sxBorderColor="transparent" sxBackground="transparent"></textarea>
    }

    @if (showDropdown && isLargeList) {
      <div sxWidth="fill" sxCursor="pointer" role="button" tabindex="0" [attr.aria-label]="label || null"
        (click)='openSuperSelect()' (keydown.enter)='openSuperSelect()' (keydown.space)='openSuperSelect()'
        sxRow sxDistribution='spaceBetween' sxAlign='center'>
        @if (!value) {
          <p sxColor='two' sxMargin='0'>{{ placeholder ? placeholder : "Select" }}</p>
        }
        <p sxMargin='0' sxCapitalize=''>{{ selectedLabel }}</p>
        <ion-icon name='caret-down-outline' [style.font-size]="'13px'" sxColor='two'></ion-icon>
      </div>
    }

    @if (type === 'dropdown' && checkBoxRequired) {
      <ion-radio-group sxWidth="full" [(ngModel)]="value"
        (ngModelChange)="onValueChange()" (ionChange)="doValidation()">
        <ion-list>
          @for (option of displayOptions; track option) {
            <ion-item>
              <ion-label>{{ getLabel(option) }}</ion-label>
              <ion-radio slot="start" [value]="option"></ion-radio>
            </ion-item>
          }
        </ion-list>
      </ion-radio-group>
    }

    @if (showDropdown && !isLargeList) {
      <div class="select-wrapper" sxRow sxAlign="center" sxWidth="full">
        @if (!value) {
          <p sxColor="two" sxMargin="0">Select</p>
        }
        <select sxWidth="fill" [(ngModel)]="value" [title]="label" [attr.aria-label]="label || null"
          [attr.aria-required]="required" [attr.aria-invalid]="!!errorNote" (ngModelChange)="onValueChange()"
          (change)="doValidation()">
          @for (option of displayOptions; track option) {
            <option [ngValue]="option">{{ getLabel(option) }}</option>
          }
        </select>
        <ion-icon sxTextSize="14px" sxColor="two" name="caret-down-outline"></ion-icon>
      </div>
    }

  </div>

  @if (errorNote || helpNote) {
    <div [id]="describedById" sxGap="5px" sxCol sxPadding="0 12px">
      <p sxTextSize="small" sxColor="danger" sxMargin="0" [attr.role]="errorNote ? 'alert' : null">{{ errorNote }}</p>
      <p sxTextSize="small" sxColor="two" sxMargin="0">{{ helpNote }}</p>
    </div>
  }


</div>
